import { FC, useRef, useEffect, SyntheticEvent } from 'react';
import cls from 'classnames';
import { GalleryLabelType } from 'shared/models';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { Link } from '@remix-run/react';

import './style.scss';

interface ImgLabelProps {
  label: GalleryLabelType;
  show: boolean;
}

export const GalleryLabel: FC<ImgLabelProps> = (props) => {
  const { label, show } = props;

  const { direction, id, name, xPct, yPct } = label;
  const nameRef = useRef<HTMLAnchorElement>(null);
  const { region } = useAtomValue($Locale);

  const isLeft = direction === 'left';

  useEffect(() => {
    const galleryName = nameRef.current;
    if (!galleryName) {
      return;
    }

    const callback = (e: TouchEvent): void => {
      e.stopPropagation();
    };

    galleryName.addEventListener('touchstart', callback);
    return () => galleryName.removeEventListener('touchstart', callback);
  }, []);

  const handleClick = (e: SyntheticEvent) => {
    e.stopPropagation();
  };

  /**
   * 兜底坐标
   *
   * @param pos - 服务器传来的坐标
   */
  const calcPos = (pos: number) => {
    if (pos < 0.03) {
      return 0.03;
    } else if (pos > 0.97) {
      return 0.97;
    }
    return pos;
  };

  return (
    <div
      className={cls('gallery-label-wrapper', {
        isShow: show,
      })}
      style={{
        left: `${calcPos(xPct) * 100}%`,
        top: `${calcPos(yPct) * 100}%`,
      }}
    >
      <div className={cls('label-dot-wrapper', { left: isLeft })}>
        <div className="label-dot-border" />
        <div className="label-dot" />
      </div>
      <Link
        to={`/topic/${id}?region=${region}`}
        className={cls('label-name', { left: isLeft, right: !isLeft })}
        ref={nameRef}
        onClick={handleClick}
      >
        #{name}
      </Link>
    </div>
  );
};
